import { optionalToJS } from './utils';

const tagFromId = (state, id) => {
  if (state.listTags.ids.includes(id)) {
    return state.entities.getIn(['listTags', id.toString()]);
  }
};

export const gettag = (state, id) => {
  if (state.entities.getIn(['listTags']) && state.listTags) {
    return optionalToJS(tagFromId(state, id));
  }
};

const tagsFromIds = (state, ids) => ids.map(id => tagFromId(state, id));

const TagsAll = (state) => tagsFromIds(state, state.listTags.ids);

export const getTagsAll = (state) => TagsAll(state).toJS();

// tags
// list tags
// add tags to playlist from frontend

// DEVICE TAGS................................

const deviceTagFromId = (state, id) => {
  if (state.deviceTags.ids.includes(id)) {
    return state.entities.getIn(['listDeviceTags', id.toString()]);
  }
};

export const getDevicetag = (state, id) => {
  if (state.entities.getIn(['listDeviceTags']) && state.deviceTags) {
    return optionalToJS(deviceTagFromId(state, id));
  }
};

const deviceTagsFromIds = (state, ids) => ids.map(id => deviceTagFromId(state, id));

const DeviceTagsAll = (state) => deviceTagsFromIds(state, state.deviceTags.ids);

export const getDeviceTagsAll = (state) => DeviceTagsAll(state).toJS();



// ASSETS TAGS................................

const assetTagFromId = (state, id) => {
  if (state.assetTags.ids.includes(id)) {
    return state.entities.getIn(['listAssetTags', id.toString()]);
  }
};

export const getAssetTag = (state, id) => {
  if (state.entities.getIn(['listAssetTags']) && state.assetTags) {
    return optionalToJS(assetTagFromId(state, id));
  }
};

const assetTagsFromIds = (state, ids) => ids.map(id => assetTagFromId(state, id));

const assetTagsAll = (state) => assetTagsFromIds(state, state.assetTags.ids);

export const getAssetTagsAll = (state) => assetTagsAll(state).toJS();


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/tags.js